import { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import {
  useNotify,
  SimpleForm,
  PasswordInput,
  useRefresh,
  required,
  useTranslate,
  useUpdate,
  useResourceContext,
  useGetIdentity,
} from "react-admin";
import SaveDeleteBtns from "../saveDeleteBtns/SaveDeleteBtn";

const passwordConfirmation = (value, allValues) => {
  if (value !== allValues.new_password) {
    return "Password doesn't match";
  }
  return undefined;
};
const changePassword = (value, allValues) => {
  if (typeof value === "undefined") {
    if (typeof allValues.current_password !== "undefined") {
      return "Current Password is required to change password";
    }
  }
  return undefined;
};

const validateCurrentPassword = [required(), changePassword];
const validateNewPassword = [required()];
const validateNewPasswordConfirmation = [required(), passwordConfirmation];

export default function ChangePassword({ open, setOpen }) {
  const [update] = useUpdate();
  const notify = useNotify();
  const refresh = useRefresh();
  const t = useTranslate();
  const resource = useResourceContext(); // cuman nama resource
  const { data, isLoading: identityLoading } = useGetIdentity();

  const save = useCallback(
    async (values) => {
      if (!data?.id) return;
      try {
        await update(
          resource,
          { id: data.id, data: values },
          {
            returnPromise: true,
            onSuccess: (data) => {
              notify("ra.notification.updated", {
                messageArgs: { smart_count: 1 },
              });
              setOpen(false);
              refresh();
            },
          }
        );
      } catch (error) {
        if (error.body && error.body.errors) {
          // The shape of the returned validation errors must match the shape of the form
          return error.body.errors;
        }
      }
    },
    [update, data]
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted={false}
      fullWidth={true}
      maxWidth="sm"
    >
      <SimpleForm
        warnWhenUnsavedChanges
        onSubmit={save}
        toolbar={<SaveDeleteBtns />}
        mode="onBlur"
        reValidateMode="onBlur"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pt: 0,
          }}
        >
          <DialogTitle>{t("mine.label.change_password")}</DialogTitle>
          <IconButton onClick={handleClose} sx={{ mr: "11px" }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent sx={{ alignSelf: "normal" }}>
          <PasswordInput
            variant="outlined"
            source="current_password"
            fullWidth
            validate={validateCurrentPassword}
          />

          <PasswordInput
            variant="outlined"
            source="new_password"
            fullWidth
            validate={validateNewPassword}
          />

          <PasswordInput
            variant="outlined"
            source="new_password_confirmation"
            fullWidth
            validate={validateNewPasswordConfirmation}
          />
        </DialogContent>
      </SimpleForm>
    </Dialog>
  );
}
